module.exports = __webpack_public_path__ + "img/new_index_cases13.adcf842b.png";